export default "__VITE_PUBLIC_ASSET__35b77850__"